module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"camera":"Камера","cameras":"Камеры","main":"Основное","tracks":"Треки","image":"Отображение направления","road":"Данные по состоянию дорожного полотна","air":"Данные по состоянию воздуха"},"en":{"camera":"Camera","cameras":"Cameras","main":"Main","tracks":"Tracks","image":"Direction display","road":"Road surface data","air":"Air data"}}')
  delete Component.options._Ctor
}
